import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  TextField,
} from "@mui/material";
import {
  fonts,
  selectStyles,
  textFieldStyles,
} from "../../../../../Styles/Styles";

const Filter = ({
  searchQuery,
  onSearchChange,
  createdDateOrder,
  onCreatedDateOrderChange,
  priceOrder,
  onPriceOrderChange,
  status,
  onStatusChange,
  offersOrder,
  onOffersOrderChange,
}) => {
  return (
    <Box sx={{ mt: 2, mb: 3, width: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Search by Title"
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={onSearchChange}
            sx={{ ...textFieldStyles }}
          />
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          >
            <InputLabel sx={{ ...fonts }}>Created Date</InputLabel>
            <Select
              value={createdDateOrder}
              onChange={(e) => onCreatedDateOrderChange(e.target.value)}
              label="Created Date"
              sx={{ ...selectStyles, borderRadius: "8px" }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                None
              </MenuItem>
              <MenuItem value="asc" sx={{ ...fonts }}>
                Ascending
              </MenuItem>
              <MenuItem value="desc" sx={{ ...fonts }}>
                Descending
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          >
            <InputLabel sx={{ ...fonts }}>Price</InputLabel>
            <Select
              value={priceOrder}
              onChange={(e) => onPriceOrderChange(e.target.value)}
              label="Price"
              sx={{ ...selectStyles, borderRadius: "8px" }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                None
              </MenuItem>
              <MenuItem value="asc" sx={{ ...fonts }}>
                Low to High
              </MenuItem>
              <MenuItem value="desc" sx={{ ...fonts }}>
                High to Low
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          >
            <InputLabel sx={{ ...fonts }}>Status</InputLabel>
            <Select
              value={status}
              onChange={(e) => onStatusChange(e.target.value)}
              label="Status"
              sx={{ ...selectStyles, borderRadius: "8px" }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                All
              </MenuItem>
              <MenuItem value="true" sx={{ ...fonts }}>
                Sold
              </MenuItem>
              <MenuItem value="false" sx={{ ...fonts }}>
                Available
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3}>
          <FormControl
            fullWidth
            variant="outlined"
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          >
            <InputLabel sx={{ ...fonts }}>Offers</InputLabel>
            <Select
              value={offersOrder}
              onChange={(e) => onOffersOrderChange(e.target.value)}
              label="Offers"
              sx={{ ...selectStyles, borderRadius: "8px" }}
            >
              <MenuItem value="" sx={{ ...fonts }}>
                None
              </MenuItem>
              <MenuItem value="asc" sx={{ ...fonts }}>
                Fewest First
              </MenuItem>
              <MenuItem value="desc" sx={{ ...fonts }}>
                Most First
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filter;
